import React, { useContext, useMemo } from 'react'
import PropTypes from 'prop-types'

import Table from '../../../../../../../../../../../../../../components/Table'

import { ReactComponent as LinkIcon } from '../../../../../../../../../../../../../../assets/icons/new-tab.svg'

import { MediaOrderFormContext } from '../../../../../../../../../../../MediaOrderFormContext'

import { replaceRouteParams } from '../../../../../../../../../../../../../../helpers/url'
import { formatCurrency } from '../../../../../../../../../../../../../../helpers/numbers'

import { ROUTE_PARAMS, ROUTES } from '../../../../../../../../../../../../../../constants/routes'
import { formatDateFullYear } from '../../../../../../../../../../../../../../constants/dates'

import { bookingsColumnsStyles } from './const/columns'

import useStyles from './styles'

const ProductBookingsTable = ({ bookings }) => {
  const classes = useStyles()

  const { currency } = useContext(MediaOrderFormContext)
  const currencySymbol = currency?.symbol

  const columns = useMemo(
    () => [
      {
        header: 'Booking',
        style: bookingsColumnsStyles.booking,
        Cell: ({ media_order_sequential_id }) => media_order_sequential_id
      },
      {
        header: 'Account',
        style: bookingsColumnsStyles.account,
        Cell: ({ account_name }) => account_name
      },
      {
        header: 'Brand',
        style: bookingsColumnsStyles.brand,
        Cell: ({ brand_name }) => brand_name
      },
      {
        header: 'Campaign Name',
        style: bookingsColumnsStyles.campaign,
        Cell: ({ campaign_name }) => campaign_name
      },
      {
        header: 'Dates',
        style: bookingsColumnsStyles.dates,
        Cell: ({ date_start, date_end }) => {
          return <p>{`${formatDateFullYear(date_start)} - ${formatDateFullYear(date_end)}`}</p>
        }
      },
      {
        header: 'Cost',
        style: bookingsColumnsStyles.cost,
        Cell: ({ price }) => formatCurrency(price, { min: 2, max: 2 }, { symbol: currencySymbol })
      },
      {
        headerKey: 'url',
        style: bookingsColumnsStyles.url,
        Cell: ({ account_id, media_order }) => {
          return (
            <a
              className={classes.linkIcon}
              href={replaceRouteParams(ROUTES.mediaOrderSummaryDetails, {
                [ROUTE_PARAMS.mediaOrderId]: media_order,
                [ROUTE_PARAMS.selfAccount]: account_id
              })}
              onClick={e => e.stopPropagation()}
              target="_blank"
              rel="noreferrer"
            >
              <LinkIcon />
            </a>
          )
        }
      }
    ],
    [classes.linkIcon, currencySymbol]
  )

  const rowTemplate = useMemo(
    () => ({
      headlineRowClassName: classes.bookingsRow,
      rowClassName: classes.bookingsRow
    }),
    [classes.bookingsRow]
  )

  return (
    <Table className={classes.competingTable} cols={columns} rowTemplate={rowTemplate} data={bookings} hideFooterRow />
  )
}

ProductBookingsTable.propTypes = {
  bookings: PropTypes.array
}

export default ProductBookingsTable
